import React from 'react';
import WhiteModelList from '../../components/whiteModel/WhiteModelList';

const WhiteModels: React.FC = () => {

    return (<div>
        <WhiteModelList />
    </div>)
};

export default WhiteModels;